import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  DatePicker,
  Typography,
  Table,
  Space,
  Row,
  Col,
  Card,
  Input,
  Modal,
  Result,
} from 'antd';
import SettlementService from '../../services/SettlementService';
import { useAuth } from '../../hooks/useAuth';
import dayjs from 'dayjs';
import './settlement.css';
import TradeProcessService from '../../services/TradeProcessService';
import { v4 as uuidv4 } from 'uuid';

const { Title, Text } = Typography;

const Settlement = () => {
  // Form control
  const [form] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState('');
  const { showNotification } = useAuth();
  const [loading, setLoading] = useState(false);
  // const [pendingSettlementList, setPendingSettlementList] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [matchingData, setMatchingData] = useState({
    success: false,
    settlementStatusType: '',
    matchingRecords: [],
  });

  const clearMatchingRecords = () => {
    setMatchingData(prevState => ({
      ...prevState,
      success: false,
      matchingRecords: [],
    }));
  };

  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
  };

  // const pendingSettlementTable = [
  //   {
  //     title: 'Settlement ID',
  //     dataIndex: 'settlementId',
  //     key: 'settlementId',
  //   },
  //   {
  //     title: 'Settlement Stage',
  //     dataIndex: 'settlementStage',
  //     key: 'settlementStage',
  //   },
  //   {
  //     title: 'Settlement Window',
  //     dataIndex: 'settlementWindow',
  //     key: 'settlementWindow',
  //   },
  //   {
  //     title: 'Trade Window',
  //     dataIndex: 'tradeWindow',
  //     key: 'tradeWindow',
  //   },
  //   {
  //     title: 'Credit Amount',
  //     dataIndex: 'creditAmount',
  //     key: 'creditAmount',
  //   },
  //   {
  //     title: 'Action',
  //     dataIndex: 'action',
  //     key: 'action',
  //     render: (_, record) => (
  //       <Button
  //         type="primray"
  //         size="middle"
  //         onClick={() => PerformCreditSettlement(record.settlementWindow)}
  //       >
  //         Settle
  //       </Button>
  //     ),
  //   },
  // ];

  // const PerformCreditSettlement = async settlementWindow => {
  //   const result = await SettlementService.creditSettlement({ settlementWindow });

  //   console.log(result);

  //   if (result.success) {
  //     showNotification(result.message, `${result.totalCreditAmount} has been settled`);
  //   } else {
  //     showNotification('error', result.message);
  //   }
  // };

  const TextItem = (text, isSame) => {
    return (
      <Text style={isSame ? { color: 'green', fontWeight: 'bold' } : { color: 'red' }}>{text}</Text>
    );
  };

  const matchingTable = [
    {
      title: (
        <Title level={5} style={{ margin: 0 }}>
          Brokerage
        </Title>
      ),
      children: [
        {
          title: 'Ref No',
          dataIndex: 'transferRefNoAtBroker',
          key: 'transferRefNoAtBroker',
          className: 'left-table',
          render: (text, record) => TextItem(text, record.same),
        },
        {
          title: 'IsIn Code',
          dataIndex: 'isinCodeAtBroker',
          key: 'isinCodeAtBroker',
          className: 'left-table',
          render: (text, record) => TextItem(text, record.same),
        },
        {
          title: 'Quantity',
          dataIndex: 'quantityAtBroker',
          key: 'quantityAtBroker',
          className: 'left-table',
          render: (text, record) => {
            if (editingRow === record.key) {
              return (
                <Input
                  defaultValue={text}
                  onChange={e => (record.brokerage.quantityAtBroker = e.target.value)}
                  style={{ maxWidth: '80px' }}
                />
              );
            } else {
              return TextItem(Number(text).toLocaleString('en-US'), record.same);
            }
          },
        },
      ],
    },
    {
      title: (
        <Title level={5} style={{ margin: 0 }}>
          Exchange
        </Title>
      ),
      children: [
        {
          title: 'Ref No',
          dataIndex: 'transferRefNoAtExchange',
          key: 'transferRefNoAtExchange',
          className: 'right-table',
          render: (text, record) => TextItem(text, record.same),
        },
        {
          title: 'IsIn Code',
          dataIndex: 'isinCodeAtExchange',
          key: 'isinCodeAtExchange',
          className: 'right-table',
          render: (text, record) => TextItem(text, record.same),
        },
        {
          title: 'Quantity',
          dataIndex: 'quantityAtExchange',
          key: 'quantityAtExchange',
          className: 'right-table',
          render: (text, record) => TextItem(Number(text).toLocaleString('en-US'), record.same),
        },
      ],
    },
    {
      title: 'Action',
      key: 'action',
      className: 'action-section',
      align: 'center',
      render: (_, record) => (
        <>
          {editingRow === record.key ? (
            <Button
              type="primary"
              onClick={() => {
                console.log(record.key);
                setEditingRow(null);
              }}
            >
              Done
            </Button>
          ) : (
            <Button
              type="default"
              onClick={() => {
                console.log(record.key);
                setEditingRow(record.key);
              }}
              disabled={record.same}
            >
              Fix
            </Button>
          )}
        </>
      ),
    },
  ];

  // useEffect(() => {
  //   // only credit settlement ??
  //   const getPendingSettlementList = async () => {
  //     const result = await SettlementService.getPendingSettlement();

  //     console.log(result);

  //     if (result.success) {
  //       // showNotification('success', 'Settlement successful');
  //       setPendingSettlementList(result.data);
  //     } else {
  //       showNotification('error', result.message);
  //     }
  //   };
  //   getPendingSettlementList();
  // }, []);

  const matchSettlement = async formValues => {
    const payload = {
      settlementWindow: formValues.settlementWindow.format('YYYYMMDD'),
      notes: formValues.notes,
    };

    console.log(payload);
    setLoading(true);
    const result = await SettlementService.performSettlementMatching(payload);
    setLoading(false);
    if (result.success) {
      setMatchingData(result.data);
    } else {
      console.log(result);
      showNotification('error', result.message);
    }
  };

  // Modal
  const [open, setOpen] = useState(false);
  const [settlementResponse, setSettlementResponse] = useState([]);

  // Perform settlement process
  const handleSettlement = async () => {
    const settlementWindow = form.getFieldValue('settlementWindow').format('YYYYMMDD');

    const payload = {
      settlementWindow,
    };
    setLoading(true);
    const result = await SettlementService.performSettlement(payload);
    setLoading(false);
    console.log(result.data);

    if (result.success) {
      showNotification('success', 'Settlement Process completed successfully');
      // success();
      setOpen(true);
      setSettlementResponse(result.data);
      form.resetFields();
      clearMatchingRecords();
    } else {
      showNotification('error', result.message);
      // error(result.message);
      // form.resetFields();
      // clearMatchingRecords();
    }
  };

  return (
    <>
      <Modal open={open} onCancel={() => setOpen(false)} footer={null} width={1000} centered>
        <Result
          status="success"
          title="Settlement Process Successful"
          // subTitle={`Matching ID: ${settlementResponse.matchingProcessId}, Settlement ID: ${settlementResponse.settlementProcessId}, Settlement Window: ${settlementResponse.settlementWindow}`}
          subTitle={
            <Row gutter={[16, 16]} style={{ marginTop: '2rem' }}>
              <Col
                xs={{
                  span: 24,
                }}
                md={{
                  span: 12,
                }}
                lg={{
                  span: 8,
                }}
              >
                <Card title="Matching Process ID">{settlementResponse.matchingProcessId}</Card>
              </Col>
              <Col
                xs={{
                  span: 24,
                }}
                md={{
                  span: 12,
                }}
                lg={{
                  span: 8,
                }}
              >
                <Card title="Settlement Process ID">{settlementResponse.settlementProcessId}</Card>
              </Col>
              <Col
                xs={{
                  span: 24,
                }}
                md={{
                  span: 12,
                }}
                lg={{
                  span: 8,
                }}
              >
                <Card title="Settlement Window">{settlementResponse.settlementWindow}</Card>
              </Col>
            </Row>
          }
        />
      </Modal>
      <Title level={4} style={{ margin: '0 0 1rem 0' }}>
        Settlement Process
      </Title>

      <div className="form-wrapper">
        <Form
          onFinish={matchSettlement}
          form={form}
          layout={window.innerWidth < 480 ? 'horizontal' : 'inline'}
        >
          <Form.Item
            label="Settlement Window (T+3)"
            name={'settlementWindow'}
            rules={[
              {
                required: true,
                message: 'Please choose date',
              },
            ]}
            initialValue={dayjs()}
          >
            <DatePicker
              style={{
                width: '100%',
              }}
              size="middle"
            />
          </Form.Item>

          <Form.Item
            label={'Notes'}
            name={'notes'}
            rules={[
              {
                required: true,
                message: 'Please add notes',
              },
            ]}
          >
            <Input placeholder="Note" />
          </Form.Item>

          <Button
            type="primary"
            size="middle"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
            loading={loading}
          >
            Match
          </Button>
        </Form>
      </div>

      {/* Matching Table */}
      <Table
        loading={loading}
        style={{ paddingTop: '1rem' }}
        columns={matchingTable}
        dataSource={matchingData.matchingRecords.map((record, i) => ({ ...record, key: i }))}
        size="large"
        bordered
        scroll={{
          x: 'max-content',
        }}
      />

      <Button
        type={'primary'}
        disabled={!matchingData.success}
        onClick={handleSettlement}
        className="confirm-button"
        style={matchingData.settlementStatusType === 'SP_COMPLETED' ? { display: 'none' } : {}}
        loading={loading}
      >
        Settle
      </Button>
    </>
  );
};

export default Settlement;
